import { render, staticRenderFns } from "./groupPlans.vue?vue&type=template&id=3f54362d&scoped=true&"
import script from "./groupPlans.vue?vue&type=script&lang=js&"
export * from "./groupPlans.vue?vue&type=script&lang=js&"
import style0 from "./groupPlans.vue?vue&type=style&index=0&id=3f54362d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54362d",
  null
  
)

export default component.exports